/**
 * Created by kaiyan2 on 26/01/2017.
 */
import React from 'react';
import DOMPurify from 'dompurify';
import LearningLabTrack from '../learningLabTrack/LearningLabTrack';
import LearningLabList from '../learningLabList/LearningLabList';
import LearningLabModule from '../learningLabModule/LearningLabModule';

class SafeHtmlPreview extends React.Component {
  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
  }
  componentDidMount() {
    if (this.containerRef.current) {
      this.containerRef.current.innerHTML = DOMPurify.sanitize(this.props.html || '');
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.html !== this.props.html && this.containerRef.current) {
      this.containerRef.current.innerHTML = DOMPurify.sanitize(this.props.html || '');
    }
  }
  render() {
    return React.createElement(this.props.tagName || 'div', {
      className: this.props.className,
      ref: this.containerRef
    });
  }
}

class LearningLab extends React.Component {
  render() {
    const { config, location, type } = this.props;

    if (!config) {
      return <span>Loading</span>
    }

    const style = config.dataset.background && {
      background: config.dataset.background
    }

    const tracks = Array.from(config.querySelectorAll("learningtrack")).map((track, index) => {
      return <div className="col-md-6 col-sm-12 pubhub-learning-lab-track pubhub-llab-item-col" key={index}>
        <LearningLabTrack config={track} location={location} />
      </div>
    });

    const modules = Array.from(config.querySelectorAll("learningmodule")).map((module, index) => {
      return <div className="col-md-6 col-sm-12 pubhub-llab-item-col" key={index}>
        <LearningLabModule config={module} location={location} />
      </div>
    });

    const lists = Array.from(config.querySelectorAll("learninglist")).map((list, index) => {
      return <div className="col-md-6 col-sm-12 pubhub-learning-lab-list pubhub-llab-item-col" key={index}>
        <LearningLabList config={list} location={location} />
      </div>
    });

    const titleElement = config.queryChild("richtitle") || config.queryChild("title");
    const title = titleElement ? titleElement.innerHTML.trim() : null;
    const descElement = config.queryChild("description");
    const description = descElement && (
      <SafeHtmlPreview className="pubhub-learning-lab-desc" html={descElement.innerHTML} />
    );

    const id = config.id ? config.id : undefined;
    const className = (config.dataset.className || config.className);

    return (
      <div id={id} className={"pubhub-learning-lab pubhub-widget" + (className ? (' ' + className) : '')} style={style}>
        <div className="container">
          <SafeHtmlPreview tagName="h1" className="pubhub-learning-lab-title" html={title} />
          {description}
          <div className="row">
            {tracks}
            {modules}
            {lists}
          </div>
        </div>
      </div>
    )
  }
}

export default LearningLab;
